import { FormattedMessage } from 'react-intl';
import React from 'react';
import { FULFILLMENTS_VIEW_ID } from './view-id-constants';

import { CancelFulfillmentButton } from '../../../shipping/fulfillments/components/cancel-fulfillment-button';
import { UpdateStatusButton } from '../../../shipping/fulfillments/components/update-status-button';
import { CreateReturnButton } from '../../../shipping/fulfillments/components/create-return-button';
import { SendNotificationsButton } from '../../../shipping/fulfillments/components/send-notifications-button';
import { NotifyMarketplaceButton } from '../../../shipping/fulfillments/components/notify-marketplace-button';
import { ExportFulfillmentsButtonExtended } from '../../../shipping/fulfillments/components/export-fulfillments-button-extended';

export const Fulfillments = {
  label: <FormattedMessage defaultMessage='Fulfillments' description='shipping page left nav item for fulfillments' id='dK7wjM' />,
  id: FULFILLMENTS_VIEW_ID,
  navigationOverride: '/shipments/fulfillments',

  buttons: [
    <CancelFulfillmentButton key='cancelFulfillment' />,
    <UpdateStatusButton key='updateStatus' />,
    <SendNotificationsButton key='sendNotifications' />,
    <NotifyMarketplaceButton key='notifyMarketplace' />,
    <CreateReturnButton key='createReturn' />,
    <ExportFulfillmentsButtonExtended key='exportFulfillmentsExtended' />,
  ],
};
